import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import RectIcon from 'images/common/chart/rect';

import { makeStyles } from '@material-ui/core/styles';
import CurrentStatus from 'components/atoms/CurrentStatus';
import ChartTooltip from './ChartTooltip';

const PercentBarChartStyle = makeStyles((theme) => ({
  PercentBarChartWrap: {
    height: 90,
    marginBottom: '0 !important',
    '&.loading': {
      height: 'auto',
      padding: 40,
    },
  },
  legendUl: {
    width: '75%',
    margin: '0 auto',
    listStyle: 'none',
    textAlign: 'center',
  },
  li: {
    display: 'inline-block',
    margin: 0,
    marginRight: '10px',
    cursor: 'pointer',
    '&.invisible': {
      opacity: 0.5,
    },
  },
}));

/**
 * legend 컴포넌트
 * @param {json} props
 */
const PercentBarChart = (props) => {
  const {
    data,
    loading = false,
    title = '',
    color = ['#268b1f', '#f15c80', '#e4d354', '#8085e8', '#8d4653'],
    barSize = 50,
  } = props;

  const classes = PercentBarChartStyle();

  const [resultData, setResultData] = useState({
    label: [],
    keyName: {},
    value: {},
  });
  const [visible, setVisible] = useState({});

  useEffect(() => {
    setVisible(() => {
      let result = {};
      for (let value of resultData.label) {
        result[value] = false;
      }
      return result;
    });
  }, [resultData.label]);

  useEffect(() => {
    let newValue = {};
    let dataResult = 0;
    let newLabel = [];
    let newKeyName = {};

    for (let value of data.data) {
      dataResult = parseInt(dataResult) + parseInt(value['val']);
    }

    for (let i = 0; i < data.data.length; i++) {
      newLabel.push('item' + i);
      newValue['item' + i] = (parseInt(data.data[i]['val']) / dataResult) * 100;
      newKeyName['item' + i] = data.data[i]['name'];
    }

    newValue['name'] = data.title;

    setResultData({
      ...resultData,
      label: newLabel,
      keyName: newKeyName,
      value: newValue,
    }); //eslint-disable-next-line
  }, [data]);

  // 클릭 이벤트를 통해 숨김 처리 할 경우를 대비해서 만들었으나 현재 사용안함으로 주석처리
  // const handleLegendClick = (e) => {
  //   const index = e._targetInst.index;
  //   let newVisible = { ...visible };
  //   newVisible[resultData.label[index]] = !newVisible[resultData.label[index]];
  //   setVisible(newVisible);
  // };

  const CustomizedLegend = (props) => {
    const { visible } = props;

    return (
      <div className={classes.legendUl}>
        {data.data.map((entry, index) => {
          return (
            <p
              className={clsx(classes.li, {
                invisible: visible[resultData.label[index]],
              })}
              key={index}
              // onClick={handleLegendClick}
            >
              <RectIcon fill={color[index]} /> {entry.name}
            </p>
          );
        })}
      </div>
    );
  };

  const makeTootipContent = (props) => {
    return renderTooltipContent({
      ...props,
    });
  };

  const renderTooltipContent = ({
    label,
    keyLabel = resultData.keyName,
    payload,
    dataKeys,
  }) => {
    let newPayLoad = [];
    for (let i = 0; i < payload.length; i++) {
      let newItem = {
        ...payload[i],
        value: data.data[i]['val'],
      };
      newPayLoad.push(newItem);
    }

    return (
      <ChartTooltip
        label={label}
        payload={newPayLoad}
        keyLabel={keyLabel}
        dataKeys={dataKeys}
        isPercentBar
        percentValue={resultData.value}
      />
    );
  };

  return (
    <div
      className={clsx(classes.PercentBarChartWrap, {
        loading: loading === true,
      })}
    >
      {loading ? (
        <CurrentStatus />
      ) : (
        <>
          {title && (
            <div>
              <h3>{title}</h3>
            </div>
          )}
          <ResponsiveContainer width={'100%'} height={80}>
            <BarChart
              key={resultData.code}
              data={[resultData.value]}
              layout="vertical"
            >
              <XAxis type="number" hide={true} />
              <YAxis type="category" dataKey="name" hide={true} />
              <Tooltip
                content={makeTootipContent}
                wrapperStyle={{ zIndex: '99' }}
              />
              <Legend
                verticalAlign="top"
                visible={visible}
                content={<CustomizedLegend />}
                //wrapperStyle={{ top: 'auto' }}
              />
              {/* eslint-disable-next-line array-callback-return */}
              {resultData.label.map((item, index) => {
                if (visible[item] === false) {
                  return (
                    <Bar
                      key={index}
                      stackId="bar"
                      dataKey={item}
                      fill={color[index]}
                      barSize={barSize || 100}
                    />
                  );
                }
              })}
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default PercentBarChart;
